export enum TournamentAgeGroupEnum {
  UnderEighteen = "U18",
  UnderTwenty = "U20",
  Senior = "SENIOR",
}
